/**
 * Do not edit directly
 * Generated on Wed, 24 Aug 2022 12:48:09 GMT
 */

module.exports = {
  borderRadius_0: "0",
  borderRadius_100: "1px",
  borderRadius_200: "2px",
  borderRadius_pill: "9999em",
  borderRadius_circle: "50%",
  borderWidth_0: "0",
  borderWidth_100: "1px",
  borderWidth_200: "2px",
  color_brand_orange: "#fA6423",
  color_brand_gray: "#55555A",
  color_brand_blue: "#37AADC",
  color_yellow_100: "#FFFADB",
  color_yellow_200: "#FFF4B5",
  color_yellow_300: "#FFE75C",
  color_yellow_400: "#FFDA00",
  color_yellow_500: "#E3AD0B",
  color_yellow_600: "#B58C12",
  color_yellow_700: "#876A2F",
  color_yellow_800: "#614D27",
  color_yellow_900: "#523E21",
  color_yellow_1000: "#3D3121",
  color_green_100: "#E8FFF7",
  color_green_200: "#D6FFF1",
  color_green_300: "#B5F5E0",
  color_green_400: "#8DEBCB",
  color_green_500: "#52D9AC",
  color_green_600: "#28BD8B",
  color_green_700: "#009F6A",
  color_green_800: "#067852",
  color_green_900: "#1B5441",
  color_green_1000: "#233B33",
  color_teal_100: "#E3FFFF",
  color_teal_200: "#CCFFFF",
  color_teal_300: "#96FEFF",
  color_teal_400: "#6EF4F5",
  color_teal_500: "#37E4E6",
  color_teal_600: "#13BEBF",
  color_teal_700: "#199091",
  color_teal_800: "#226363",
  color_teal_900: "#274C4D",
  color_teal_1000: "#223A3B",
  color_blue_100: "#F2F8FF",
  color_blue_200: "#E8F3FF",
  color_blue_300: "#CCE3FF",
  color_blue_400: "#ABD2FF",
  color_blue_500: "#78B6FF",
  color_blue_600: "#429BFF",
  color_blue_700: "#1273E6",
  color_blue_800: "#0060CC",
  color_blue_900: "#1A497D",
  color_blue_1000: "#203752",
  color_purple_100: "#F9F5FF",
  color_purple_200: "#F3EBFF",
  color_purple_300: "#E5D4FF",
  color_purple_400: "#D7BDFF",
  color_purple_500: "#BD91FF",
  color_purple_600: "#A469FF",
  color_purple_700: "#8C40FF",
  color_purple_800: "#7122E3",
  color_purple_900: "#4C2E87",
  color_purple_1000: "#352E4A",
  color_magenta_100: "#FFF2F8",
  color_magenta_200: "#FFE8F2",
  color_magenta_300: "#FFCCE3",
  color_magenta_400: "#FFB0D3",
  color_magenta_500: "#FF7DB7",
  color_magenta_600: "#F0549A",
  color_magenta_700: "#D1347A",
  color_magenta_800: "#992659",
  color_magenta_900: "#782449",
  color_magenta_1000: "#522338",
  color_red_100: "#FFF2F3",
  color_red_200: "#FFEBEC",
  color_red_300: "#FFCFD1",
  color_red_400: "#FFB5B9",
  color_red_500: "#FF858B",
  color_red_600: "#FF5760",
  color_red_700: "#D9363E",
  color_red_800: "#A12B2B",
  color_red_900: "#80252A",
  color_red_1000: "#5C2121",
  color_gray_100: "#F5F8FA",
  color_gray_200: "#EBF0F5",
  color_gray_300: "#D9E0E6",
  color_gray_400: "#C5CED6",
  color_gray_500: "#A2ADB8",
  color_gray_600: "#818E9A",
  color_gray_700: "#626F7A",
  color_gray_800: "#46525C",
  color_gray_900: "#39444D",
  color_gray_1000: "#2C353D",
  color_white: "#FFFFFF",
  boxShadow_0: "none",
  boxShadow_100: "0px 1px 2px rgba(44,53,61,.2)",
  boxShadow_200: "0px 2px 4px rgba(44,53,61,.2)",
  boxShadow_300: "0px 4px 8px rgba(44,53,61,.2)",
  boxShadow_400: "0px 8px 16px rgba(44,53,61,.2)",
  zIndex_auto: "auto",
  zIndex_below: "-1",
  zIndex_default: "1",
  zIndex_above: "10",
  zIndex_overlay: "1000",
  fontFamily_sans: "'Calibre', -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, Helvetica, sans-serif",
  fontFamily_monospace: "'SFMono-Regular', Monaco, Consolas, 'Lucida Console', monospace",
  lineHeight_100: "1rem",
  lineHeight_200: "1.25rem",
  lineHeight_300: "1.5rem",
  lineHeight_400: "1.750rem",
  lineHeight_500: "2rem",
  lineHeight_600: "2.5rem",
  lineHeight_700: "3.5rem",
  lineHeight_800: "4.25rem",
  fontSize_50: "0.75rem",
  fontSize_100: "0.875rem",
  fontSize_200: "1rem",
  fontSize_300: "1.125rem",
  fontSize_400: "1.25rem",
  fontSize_500: "1.5rem",
  fontSize_600: "2rem",
  fontSize_700: "2.75rem",
  fontSize_800: "3.5rem",
  fontSize_root: "16px",
  fontWeight_light: "300",
  fontWeight_normal: "400",
  fontWeight_medium: "500",
  fontWeight_semibold: "600",
  mediaQuery_xs: "448px",
  mediaQuery_sm: "720px",
  mediaQuery_md: "960px",
  mediaQuery_lg: "1200px",
  mediaQuery_xl: "1440px",
  motionDuration_fast: "0.15s",
  motionDuration_medium: "0.3s",
  motionDuration_slow: "0.7s",
  motionEase_in: "cubic-bezier(.35, 0, .7, .2)",
  motionEase_out: "cubic-bezier(0, 0, .3, 1)",
  motionEase_in_out: "cubic-bezier(.4, 0, .3, 1)",
  sizing_0: "0rem",
  sizing_100: "0.25rem",
  sizing_200: "0.5rem",
  sizing_300: "0.75rem",
  sizing_400: "1rem",
  sizing_450: "1.25rem",
  sizing_500: "1.5rem",
  sizing_550: "1.75rem",
  sizing_600: "2rem",
  sizing_650: "2.5rem",
  sizing_700: "3rem",
  sizing_750: "3.5rem",
  sizing_800: "4rem",
  sizing_850: "6rem",
  sizing_900: "10rem",
  sizing_1000: "20rem",
  sizing_1100: "28rem",
  sizing_1150: "35rem",
  sizing_1200: "45rem",
  sizing_1300: "60rem",
  sizing_1350: "66rem",
  sizing_1400: "75rem",
  sizing_1500: "90rem",
  spacing_0: "0rem",
  spacing_100: "0.25rem",
  spacing_200: "0.5rem",
  spacing_300: "0.75rem",
  spacing_400: "1rem",
  spacing_450: "1.25rem",
  spacing_500: "1.5rem",
  spacing_550: "1.75rem",
  spacing_600: "2rem",
  spacing_650: "2.5rem",
  spacing_700: "3rem",
  spacing_750: "3.5rem",
  spacing_800: "4rem",
  spacing_850: "6rem",
  spacing_900: "10rem"
};